<header class="header" role="banner">
    <nav class="navbar navbar-expand-md main-nav bg-white" role="navigation">
        <div class="container d-f-destkop position-relative px-md-1">

            <ul class="nav navbar-nav d-lg-flex justify-content-between flex-grow-1 flex-lg-grow-0 disabled-column">
                <li class="nav-item d-lg-flex justify-content-md-start">
                    <a class="navbar-brand" [routerLink]="['/']"
                       routerLinkActive="active" #rla_="routerLinkActive" [routerLinkActiveOptions]="{exact: true}"
                       [attr.aria-current]="rla_.isActive ? 'page' : null"
                       [attr.aria-label]="'global.menu.logo-accueil' | translate"
                       (click)="collapseNavbar()">
                        <logo-marianne>Ministère<br>de la Justice</logo-marianne>
                    </a>
                </li>

                <li class="nav-item d-flex align-items-center d-md-none">
                    <button class="nav-button-menu-burger jh-navbar-toggler d-lg-none ms-1" data-toggle="collapse"
                       data-target="#navbarResponsive" aria-controls="navbarResponsive"
                       [attr.aria-expanded]="!isNavbarCollapsed"
                       [attr.aria-label]="'global.menu.toggle-navigation' | translate" (click)="toggleNavbar()">
                        <span class="d-none">Menu</span>
                    </button>
                </li>
            </ul>
            <div class="navbar-collapse collapse"
                 id="navbarResponsive" [ngbCollapse]="isNavbarCollapsed" *ngIf="isAuthenticated()">
                <ul class="nav navbar-nav mx-auto px-sm-3 px-xl-0 flex-nowrap">
                    <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <a class="nav-link" #firstNavLink routerLink="/"
                           routerLinkActive="active" #rla1="routerLinkActive"
                           [routerLinkActiveOptions]="{exact: true}"
                           [attr.aria-current]="rla1.isActive ? 'page' : null"
                           (click)="collapseNavbar()">
                            <span translate="global.menu.home"></span>
                        </a>
                    </li>
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" routerLink="/parloir"
                           (click)="collapseNavbar()"
                           routerLinkActive="active" #rla2="routerLinkActive"
                           [attr.aria-label]="'global.menu.parloir-lien' | translate"
                           [attr.aria-current]="rla2.isActive ? 'page' : null"
                        >
                            <span translate="global.menu.parloir"></span>
                        </a>
                    </li>
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" routerLink="/pecule"
                           (click)="collapseNavbar()"
                           routerLinkActive="active" #rla3="routerLinkActive"
                           [attr.aria-label]="'global.menu.pecule-lien' | translate"
                           [attr.aria-current]="rla3.isActive ? 'page' : null"
                        >
                            <span translate="global.menu.pecule"></span>
                        </a>
                    </li>
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" [routerLink]="['/permisvisiteV2']" [state]="{idCarteDetenu: ''}"
                           (click)="collapseNavbar()"
                           routerLinkActive="active" #rla5="routerLinkActive"
                           [attr.aria-label]="'global.menu.permis-visite-lien-2' | translate"
                           [attr.aria-current]="rla5.isActive ? 'page' : null"
                        >
                            <span translate="global.menu.permis-visite-2"></span>
                        </a>
                    </li>

                    <li ngbDropdown #dropAide="ngbDropdown" placement="bottom-start"
                        (click)="onClick(dropAide, $event)"
                        (mouseenter)="onMouseenter(dropAide)" (mouseleave)="onMouseleave(dropAide)"
                        class="nav-item dropdown dropdown--aide d-block"
                        [ngClass]="{'active': rla6.isActive || rla7.isActive || rlaContact.isActive}">
                        <button #dropAideEl class="nav-link ps-2 pe-4 d-none d-md-block"
                                [ngClass]="{'dropdown-active': rla6.isActive || rla7.isActive || rlaContact.isActive}"
                                ngbDropdownToggle>
                            <span translate="global.menu.aide" class="caret"></span>
                        </button>
                        <ul class="dropdown-menu border-0 rounded-0 shadow nav-item py-0" ngbDropdownMenu>
                            <li class="dropdown-menu-li">
                                <a class="nav-link my-2" routerLink="/communication/faq"
                                   ngbDropdownItem
                                   (click)="collapseNavbar()"
                                   routerLinkActive="active" #rla6="routerLinkActive"
                                   [attr.aria-current]="rla6.isActive ? 'page' : null"
                                   [attr.aria-label]="'communication.faq.title' | translate"
                                ><span translate="communication.faq.title"></span></a>
                            </li>
                            <li>
                                <a class="nav-link my-2" routerLink="/tutoriel"
                                   ngbDropdownItem
                                   (click)="collapseNavbar()"
                                   routerLinkActive="active" #rla7="routerLinkActive"
                                   [attr.aria-current]="rla7.isActive ? 'page' : null"
                                   [attr.aria-label]="'tutoriel.page.titre' | translate"
                                ><span translate="tutoriel.title"></span></a>
                            </li>
                            <li>
                                <a class="nav-link my-2" routerLink="/contact"
                                   ngbDropdownItem
                                   (click)="collapseNavbar()"
                                   routerLinkActive="active" #rlaContact="routerLinkActive"
                                   [routerLinkActiveOptions]="{exact: true}"
                                   [attr.aria-current]="rlaContact.isActive ? 'page' : null"
                                   [attr.aria-label]="'contact.titre' | translate"
                                ><span translate="contact.titre"></span></a>
                            </li>
                        </ul>
                    </li>
                </ul>

                <ul class="nav navbar-nav px-3 px-md-0 max-with-300-custom top-auto">
                    <li ngbDropdown placement="bottom-end" class="nav-item dropdown dropdown--account">
                        <a class="nav-link d-flex align-items-center"
                           [class.dropdown-active]="rla8.isActive"
                           ngbDropdownToggle href="javascript:">
                            <span class="picto utils picto-user"></span>
                            <span class="d-flex d-md-none d-lg-inline text-wrap">{{ nomPrenom }}</span>
                        </a>
                        <ul class="dropdown-menu text-center" ngbDropdownMenu>
                            <li class="nav-item">
                                <a class="nav-link text-uppercase pb-2"
                                   ngbDropdownItem
                                   #accountLink
                                   routerLink="/moncompte"
                                   routerLinkActive="active"
                                   #rla8="routerLinkActive"
                                   [attr.aria-current]="rla8.isActive ? 'page' : null"
                                   (click)="collapseNavbar()"
                                   translate="global.menu.account.main"></a>
                            </li>
                            <li class="nav-item mt-0">
                                <button class="nav-link text-uppercase pb-2"
                                   ngbDropdownItem
                                   routerLinkActive="active"
                                   (click)="deconnexion()"
                                   translate="global.menu.account.logout"></button>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            <div class="navbar-collapse collapse d-md-flex justify-content-center" id="navbarResponsiveNotConnected"
                 role="navigation"
                 [ngbCollapse]="isNavbarCollapsed" *ngIf="!isAuthenticated()">
                <ul class="navbar-nav navbar-nav--offset">
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" routerLink="/authentification"
                           routerLinkActive="active"
                           #rla1_="routerLinkActive"
                           [attr.aria-current]="rla1_.isActive ? 'page' : null"
                           (click)="collapseNavbar()">
                            <span translate="global.menu.home"></span>
                        </a>
                    </li>
                    <li class="nav-item" routerLinkActive="active" (click)="collapseNavbar()">
                        <a class="nav-link" routerLink="/communication/faq"
                           routerLinkActive="active"
                           #rla2_="routerLinkActive"
                           [attr.aria-current]="rla2_.isActive ? 'page' : null"
                        >
                            <span translate="communication.faq.title"></span>
                        </a>
                    </li>
                    <li class="nav-item" routerLinkActive="active" (click)="collapseNavbar()">
                        <a class="nav-link" routerLink="/contact"
                           routerLinkActive="active"
                           #rla3_="routerLinkActive"
                           [attr.aria-current]="rla3_.isActive ? 'page' : null"
                        >
                            <span translate="contact.titre"></span>
                        </a>
                    </li>
                </ul>
            </div>

            <ul class="nav navbar-nav navbar-nav--fc p-right-15 d-none d-md-flex" *ngIf="!isAuthenticated()">
                <li class="nav-item lh1 d-grid">
                    <div class="fr-connect-group">
                        <button class="fr-connect" type="button"
                                (click)="connectionToFC('')">
                            <span class="fr-connect__login" translate="global.menu.france-connect-identify"></span>
                            <span class="fr-connect__brand" translate="global.menu.france-connect"></span>
                        </button>
                        <a class="navbar-france-connect france-connect-link"
                           href="https://app.franceconnect.gouv.fr/en-savoir-plus"
                           translate="global.menu.france-connect-help" target="_blank" rel="noopener noreferrer"
                           [title]="'global.menu.france-connect-title' | translate">
                        </a>
                    </div>
                </li>
            </ul>

        </div>
    </nav>
</header>
